import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DeleteMonthlyReportsRequest = {
  monthlyReportId: number;
};

export type DeleteMonthlyReportsResponse = {};

export const deleteMonthlyReport = async (request: DeleteMonthlyReportsRequest) => {
  await executeApiRequest(
    () =>
      axios.delete("/monthlyReports", {
        params: {
          monthlyReportId: request.monthlyReportId
        }
      }),
    false
  );
};
